// dash

import apiClient from '../utils/apiService';

export const dashApi = {
  getEmailSummary: () => apiClient.get('/email/summary'),
};
